import { httpRequest } from '@calendly/http-tools'

export const createExport = () => httpRequest({ url: '/api/organization/event_types/export', method: 'POST' })
